module.exports = __webpack_public_path__ + "static/VS_icon09-01-d3e2dc959c3613a497b4633f216ad811.png";